/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

export default {
  setStorage: function setStorage(keys, val) {
    //设置缓存
    var values = val;

    if (_typeof(val) == "object") {
      values = JSON.stringify(val);
    }

    sessionStorage.setItem(keys, values);
  },
  getStorage: function getStorage(keys) {
    //获取缓存
    if (!sessionStorage.getItem(keys)) {
      return null;
    }

    try {
      return JSON.parse(sessionStorage.getItem(keys));
    } catch (e) {
      return sessionStorage.getItem(keys);
    }
  }
};